module.exports = __webpack_public_path__ + "static/p13_looney-f04ddf634450ca65cdd48ae20fe74834.png";